import Api from "./api";

export const getTagsAndEnableTagsOnArticles = async (id) => {
  let data = [];
  await Api.get(`/tags/tags-and-enable-tags-on-articles/${id}`)
    .then((result) => {
      data = result.data;
    })
    .catch((err) => {
      data = err;
    });
  return data;
};

export const getTagsAndEnableTagsOnArticlesExternal = async (id, hirerId) => {
  let data = [];
  await Api.get(`/tags/tags-and-enable-tags-on-articles-external/${id}/${hirerId}`)
    .then((result) => {
      data = result.data;
    })
    .catch((err) => {
      data = err;
    });
  return data;
};

export const getTagsAndEnableTagsOnUsers = async (id) => {
  let data = [];
  await Api.get(`/tags/tags-and-enable-tags-on-users/${id}`)
    .then((result) => {
      data = result.data;
    })
    .catch((err) => {
      data = err;
    });
  return data;
};

export const getTagsAndEnableTagsOnCalleds = async (id) => {
  let data = [];
  await Api.get(`/tags/tags-and-enable-tags-on-calleds/${id}`)
    .then((result) => {
      data = result.data;
    })
    .catch((err) => {
      data = err;
    });
  return data;
};

export const searchTagsForFilter = async (q) => {
    try {
        const response = await Api.get(`/tags/autocomplete?q=${encodeURIComponent(q)}`);
        return response;
    } catch (err) {
        return err;
    }
};
